import script from "./QueriesItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./QueriesItem.vue?vue&type=script&lang=ts&setup=true"

import "./QueriesItem.vue?vue&type=style&index=0&id=1bfba17c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bfba17c"]])

export default __exports__